const LOAD_DEFAULT_QEMIS_PRI = (state) => {
  state.school_dt.res = -1
  state.school_dt.scod = ''
  state.school_dt.schENG = ''
  state.school_dt.schKH = ''
  state.school_dt.proENG = ''
  state.school_dt.proKH = ''
  state.school_dt.disENG = ''
  state.school_dt.disKH = ''
  state.school_dt.comENG = ''
  state.school_dt.comKH = ''
  state.school_dt.fid = ''      // forign key ID
  state.school_dt.g1 = ''
  state.school_dt.g2 = ''
  state.school_dt.g3 = ''
  state.school_dt.g4 = ''
  state.school_dt.g5 = ''
  state.school_dt.g6 = ''
  state.school_dt.pho_num = ''  // telephone number
  state.school_dt.sco_g1 = null
  state.school_dt.sco_g2 = null
  state.school_dt.sco_g3 = null
  state.school_dt.sco_g4 = null
  state.school_dt.sco_g5 = null
  state.school_dt.sco_g6 = null
}

const LOAD_DATA_QEMIS_PRI = (state, payload) => {
  state.school_dt = payload
}

export {
  LOAD_DEFAULT_QEMIS_PRI,
  LOAD_DATA_QEMIS_PRI
}
